import {NextPage} from "next";
import {useRouter} from "next/router";
import {CheckoutView} from "../components/checkout/CheckoutView";
import {wrapper} from "../app/store";
import {serverSideTranslations} from "next-i18next/serverSideTranslations";
import Head from "next/head";
import React from "react";
import {useAppSelector} from "../app/hooks";
import {selectPurchaseOrder} from "../redux/checkout/checkoutSlice";

const Checkout: NextPage = () => {
  const router = useRouter()
  const storeId = router.query.store_id as string

  const purchaseOrder = useAppSelector(selectPurchaseOrder)

  return <>
    <Head>
      <title>{`Checkout${purchaseOrder ? ` | ${purchaseOrder.vendor?.name}` : ''}`}</title>
      <meta property="og:url" key="og:url" content={`${process.env.NEXT_PUBLIC_APP_DOMAIN_URL}/checkout?store_id=${storeId}`}/>
      <meta property="og:title" key="og:title" content={`Checkout${purchaseOrder ? ` | ${purchaseOrder.vendor?.name}` : ''}`} />
      <meta property="twitter:title" key="twitter:title" content={`Checkout${purchaseOrder ? ` | ${purchaseOrder.vendor?.name}` : ''}`}/>
    </Head>
    <CheckoutView storeId={storeId} />
  </>
}

export const getStaticProps = wrapper.getStaticProps(store => async ({ locale }: any) => {
  return {
    props: {
      ...await serverSideTranslations(locale, ['common', 'landing', 'auth', 'location', 'store', 'payment', 'checkout', 'order']),
    }
  }
});

export default Checkout